"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _QuizResultFilter = _interopRequireDefault(require("./core-components/QuizResultFilter"));
var _helpers = require("./core-components/helpers");
var _InstantFeedback = _interopRequireDefault(require("./core-components/InstantFeedback"));
var _Explanation = _interopRequireDefault(require("./core-components/Explanation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Core = function Core(_ref) {
  var questions = _ref.questions,
    appLocale = _ref.appLocale,
    showDefaultResult = _ref.showDefaultResult,
    onComplete = _ref.onComplete,
    customResultPage = _ref.customResultPage,
    showInstantFeedback = _ref.showInstantFeedback,
    continueTillCorrect = _ref.continueTillCorrect,
    revealAnswerOnSubmit = _ref.revealAnswerOnSubmit,
    allowNavigation = _ref.allowNavigation,
    onQuestionSubmit = _ref.onQuestionSubmit;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    incorrectAnswer = _useState2[0],
    setIncorrectAnswer = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    correctAnswer = _useState4[0],
    setCorrectAnswer = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showNextQuestionButton = _useState6[0],
    setShowNextQuestionButton = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    endQuiz = _useState8[0],
    setEndQuiz = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    currentQuestionIndex = _useState10[0],
    setCurrentQuestionIndex = _useState10[1];
  var _useState11 = (0, _react.useState)({}),
    _useState12 = _slicedToArray(_useState11, 2),
    buttons = _useState12[0],
    setButtons = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    correct = _useState14[0],
    setCorrect = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    incorrect = _useState16[0],
    setIncorrect = _useState16[1];
  var _useState17 = (0, _react.useState)([]),
    _useState18 = _slicedToArray(_useState17, 2),
    userInput = _useState18[0],
    setUserInput = _useState18[1];
  var _useState19 = (0, _react.useState)('all'),
    _useState20 = _slicedToArray(_useState19, 2),
    filteredValue = _useState20[0],
    setFilteredValue = _useState20[1];
  var _useState21 = (0, _react.useState)(1),
    _useState22 = _slicedToArray(_useState21, 2),
    userAttempt = _useState22[0],
    setUserAttempt = _useState22[1];
  var _useState23 = (0, _react.useState)(true),
    _useState24 = _slicedToArray(_useState23, 2),
    showDefaultResultState = _useState24[0],
    setShowDefaultResult = _useState24[1];
  var _useState25 = (0, _react.useState)(undefined),
    _useState26 = _slicedToArray(_useState25, 2),
    answerSelectionTypeState = _useState26[0],
    setAnswerSelectionType = _useState26[1];
  var _useState27 = (0, _react.useState)(0),
    _useState28 = _slicedToArray(_useState27, 2),
    totalPoints = _useState28[0],
    setTotalPoints = _useState28[1];
  var _useState29 = (0, _react.useState)(0),
    _useState30 = _slicedToArray(_useState29, 2),
    correctPoints = _useState30[0],
    setCorrectPoints = _useState30[1];
  var _useState31 = (0, _react.useState)(questions[currentQuestionIndex]),
    _useState32 = _slicedToArray(_useState31, 2),
    question = _useState32[0],
    setQuestion = _useState32[1];
  var _useState33 = (0, _react.useState)(undefined),
    _useState34 = _slicedToArray(_useState33, 2),
    questionSummary = _useState34[0],
    setQuestionSummary = _useState34[1];
  (0, _react.useEffect)(function () {
    setShowDefaultResult(showDefaultResult !== undefined ? showDefaultResult : true);
  }, [showDefaultResult]);
  (0, _react.useEffect)(function () {
    setQuestion(questions[currentQuestionIndex]);
  }, [currentQuestionIndex]);
  (0, _react.useEffect)(function () {
    var answerSelectionType = question.answerSelectionType;
    // Default single to avoid code breaking due to automatic version upgrade
    setAnswerSelectionType(answerSelectionType || 'single');
  }, [question, currentQuestionIndex]);
  (0, _react.useEffect)(function () {
    if (endQuiz) {
      var totalPointsTemp = 0;
      var correctPointsTemp = 0;
      for (var i = 0; i < questions.length; i += 1) {
        var point = questions[i].point || 0;
        if (typeof point === 'string' || point instanceof String) {
          point = parseInt(point);
        }
        totalPointsTemp += point;
        if (correct.includes(i)) {
          correctPointsTemp += point;
        }
      }
      setTotalPoints(totalPointsTemp);
      setCorrectPoints(correctPointsTemp);
    }
  }, [endQuiz]);
  (0, _react.useEffect)(function () {
    setQuestionSummary({
      numberOfQuestions: questions.length,
      numberOfCorrectAnswers: correct.length,
      numberOfIncorrectAnswers: incorrect.length,
      questions: questions,
      userInput: userInput,
      totalPoints: totalPoints,
      correctPoints: correctPoints
    });
  }, [totalPoints, correctPoints]);
  (0, _react.useEffect)(function () {
    if (endQuiz && onComplete !== undefined && questionSummary !== undefined) {
      onComplete(questionSummary);
    }
  }, [questionSummary]);
  var nextQuestion = function nextQuestion(currentQuestionIdx) {
    setIncorrectAnswer(false);
    setCorrectAnswer(false);
    setShowNextQuestionButton(false);
    setButtons({});
    if (currentQuestionIdx + 1 === questions.length) {
      if (userInput.length !== questions.length) {
        alert('Quiz is incomplete');
      } else if (allowNavigation) {
        var submitQuiz = confirm('You have finished all the questions. Submit Quiz now?');
        if (submitQuiz) {
          setEndQuiz(true);
        }
      } else {
        setEndQuiz(true);
      }
    } else {
      setCurrentQuestionIndex(currentQuestionIdx + 1);
    }
  };
  var handleChange = function handleChange(event) {
    setFilteredValue(event.target.value);
  };
  var renderAnswerInResult = function renderAnswerInResult(question, userInputIndex) {
    var answers = question.answers,
      correctAnswer = question.correctAnswer,
      questionType = question.questionType;
    var answerSelectionType = question.answerSelectionType;
    var answerBtnCorrectClassName;
    var answerBtnIncorrectClassName;

    // Default single to avoid code breaking due to automatic version upgrade
    answerSelectionType = answerSelectionType || 'single';
    return answers.map(function (answer, index) {
      if (answerSelectionType === 'single') {
        // correctAnswer - is string
        answerBtnCorrectClassName = "".concat(index + 1) === correctAnswer ? 'correct' : '';
        answerBtnIncorrectClassName = "".concat(userInputIndex) !== correctAnswer && "".concat(index + 1) === "".concat(userInputIndex) ? 'incorrect' : '';
      } else {
        // correctAnswer - is array of numbers
        answerBtnCorrectClassName = correctAnswer.includes(index + 1) ? 'correct' : '';
        answerBtnIncorrectClassName = !correctAnswer.includes(index + 1) && userInputIndex.includes(index + 1) ? 'incorrect' : '';
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index
      }, /*#__PURE__*/_react["default"].createElement("button", {
        disabled: true,
        className: "answerBtn btn ".concat(answerBtnCorrectClassName).concat(answerBtnIncorrectClassName)
      }, questionType === 'text' && /*#__PURE__*/_react["default"].createElement("span", null, answer), questionType === 'photo' && /*#__PURE__*/_react["default"].createElement("img", {
        src: answer,
        alt: "image"
      })));
    });
  };
  var renderQuizResultQuestions = (0, _react.useCallback)(function () {
    var filteredQuestions;
    var filteredUserInput;
    if (filteredValue !== 'all') {
      if (filteredValue === 'correct') {
        filteredQuestions = questions.filter(function (question, index) {
          return correct.indexOf(index) !== -1;
        });
        filteredUserInput = userInput.filter(function (input, index) {
          return correct.indexOf(index) !== -1;
        });
      } else {
        filteredQuestions = questions.filter(function (question, index) {
          return incorrect.indexOf(index) !== -1;
        });
        filteredUserInput = userInput.filter(function (input, index) {
          return incorrect.indexOf(index) !== -1;
        });
      }
    }
    return (filteredQuestions || questions).map(function (question, index) {
      var userInputIndex = filteredUserInput ? filteredUserInput[index] : userInput[index];

      // Default single to avoid code breaking due to automatic version upgrade
      var answerSelectionType = question.answerSelectionType || 'single';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "result-answer-wrapper",
        key: index + 1
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        dangerouslySetInnerHTML: (0, _helpers.rawMarkup)("Q".concat(question.questionIndex, ": ").concat(question.question, " ").concat(appLocale.marksOfQuestion.replace('<marks>', question.point)))
      }), question.questionPic && /*#__PURE__*/_react["default"].createElement("img", {
        src: question.questionPic,
        alt: "image"
      }), renderTags(answerSelectionType, question.correctAnswer.length, question.segment), /*#__PURE__*/_react["default"].createElement("div", {
        className: "result-answer"
      }, renderAnswerInResult(question, userInputIndex)), /*#__PURE__*/_react["default"].createElement(_Explanation["default"], {
        question: question,
        isResultPage: true
      }));
    });
  }, [endQuiz, filteredValue]);
  var renderAnswers = function renderAnswers(question, buttons) {
    var answers = question.answers,
      correctAnswer = question.correctAnswer,
      questionType = question.questionType,
      questionIndex = question.questionIndex;
    var answerSelectionType = question.answerSelectionType;
    var onClickAnswer = function onClickAnswer(index) {
      return (0, _helpers.checkAnswer)(index + 1, correctAnswer, answerSelectionType, {
        userInput: userInput,
        userAttempt: userAttempt,
        currentQuestionIndex: currentQuestionIndex,
        continueTillCorrect: continueTillCorrect,
        showNextQuestionButton: showNextQuestionButton,
        incorrect: incorrect,
        correct: correct,
        setButtons: setButtons,
        setCorrectAnswer: setCorrectAnswer,
        setIncorrectAnswer: setIncorrectAnswer,
        setCorrect: setCorrect,
        setIncorrect: setIncorrect,
        setShowNextQuestionButton: setShowNextQuestionButton,
        setUserInput: setUserInput,
        setUserAttempt: setUserAttempt
      });
    };
    var onSelectAnswer = function onSelectAnswer(index) {
      return (0, _helpers.selectAnswer)(index + 1, correctAnswer, answerSelectionType, {
        userInput: userInput,
        currentQuestionIndex: currentQuestionIndex,
        setButtons: setButtons,
        setShowNextQuestionButton: setShowNextQuestionButton,
        incorrect: incorrect,
        correct: correct,
        setCorrect: setCorrect,
        setIncorrect: setIncorrect,
        setUserInput: setUserInput
      });
    };
    var checkSelectedAnswer = function checkSelectedAnswer(index) {
      if (userInput[questionIndex - 1] === undefined) {
        return false;
      }
      if (answerSelectionType === 'single') {
        return userInput[questionIndex - 1] === index;
      }
      return Array.isArray(userInput[questionIndex - 1]) && userInput[questionIndex - 1].includes(index);
    };

    // Default single to avoid code breaking due to automatic version upgrade
    answerSelectionType = answerSelectionType || 'single';
    return answers.map(function (answer, index) {
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: index
      }, buttons[index] !== undefined ? /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        disabled: buttons[index].disabled || false,
        className: "".concat(buttons[index].className, " answerBtn btn"),
        onClick: function onClick() {
          return revealAnswerOnSubmit ? onSelectAnswer(index) : onClickAnswer(index);
        }
      }, questionType === 'text' && /*#__PURE__*/_react["default"].createElement("span", null, answer), questionType === 'photo' && /*#__PURE__*/_react["default"].createElement("img", {
        src: answer,
        alt: "image"
      })) : /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick() {
          return revealAnswerOnSubmit ? onSelectAnswer(index) : onClickAnswer(index);
        },
        className: "answerBtn btn ".concat(allowNavigation && checkSelectedAnswer(index + 1) ? 'selected' : null)
      }, questionType === 'text' && answer, questionType === 'photo' && /*#__PURE__*/_react["default"].createElement("img", {
        src: answer,
        alt: "image"
      })));
    });
  };
  var renderTags = function renderTags(answerSelectionType, numberOfSelection, segment) {
    var singleSelectionTagText = appLocale.singleSelectionTagText,
      multipleSelectionTagText = appLocale.multipleSelectionTagText,
      pickNumberOfSelection = appLocale.pickNumberOfSelection;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "tag-container"
    }, answerSelectionType === 'single' && /*#__PURE__*/_react["default"].createElement("span", {
      className: "single selection-tag"
    }, singleSelectionTagText), answerSelectionType === 'multiple' && /*#__PURE__*/_react["default"].createElement("span", {
      className: "multiple selection-tag"
    }, multipleSelectionTagText), /*#__PURE__*/_react["default"].createElement("span", {
      className: "number-of-selection"
    }, pickNumberOfSelection.replace('<numberOfSelection>', numberOfSelection)), segment && /*#__PURE__*/_react["default"].createElement("span", {
      className: "selection-tag segment"
    }, segment));
  };
  var renderResult = function renderResult() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, appLocale.resultPageHeaderText.replace('<correctIndexLength>', correct.length).replace('<questionLength>', questions.length)), /*#__PURE__*/_react["default"].createElement("h2", null, appLocale.resultPagePoint.replace('<correctPoints>', correctPoints).replace('<totalPoints>', totalPoints)), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_QuizResultFilter["default"], {
      filteredValue: filteredValue,
      handleChange: handleChange,
      appLocale: appLocale
    }), renderQuizResultQuestions());
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "questionWrapper"
  }, !endQuiz && /*#__PURE__*/_react["default"].createElement("div", {
    className: "questionWrapperBody"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "questionModal"
  }, /*#__PURE__*/_react["default"].createElement(_InstantFeedback["default"], {
    question: question,
    showInstantFeedback: showInstantFeedback,
    correctAnswer: correctAnswer,
    incorrectAnswer: incorrectAnswer,
    onQuestionSubmit: onQuestionSubmit,
    userAnswer: _toConsumableArray(userInput).pop()
  })), /*#__PURE__*/_react["default"].createElement("div", null, "".concat(appLocale.question, " ").concat(currentQuestionIndex + 1, " / ").concat(questions.length, ":")), /*#__PURE__*/_react["default"].createElement("h3", {
    dangerouslySetInnerHTML: (0, _helpers.rawMarkup)("".concat(question && question.question, " ").concat(appLocale.marksOfQuestion.replace('<marks>', question.point)))
  }), question && question.questionPic && /*#__PURE__*/_react["default"].createElement("img", {
    src: question.questionPic,
    alt: "image"
  }), question && renderTags(answerSelectionTypeState, question.correctAnswer.length, question.segment), question && renderAnswers(question, buttons), (showNextQuestionButton || allowNavigation) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "questionBtnContainer"
  }, allowNavigation && currentQuestionIndex > 0 && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return nextQuestion(currentQuestionIndex - 2);
    },
    className: "prevQuestionBtn btn",
    type: "button"
  }, appLocale.prevQuestionBtn), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return nextQuestion(currentQuestionIndex);
    },
    className: "nextQuestionBtn btn",
    type: "button"
  }, appLocale.nextQuestionBtn))), endQuiz && showDefaultResultState && customResultPage === undefined && renderResult(), endQuiz && !showDefaultResultState && customResultPage !== undefined && customResultPage(questionSummary));
};
var _default = exports["default"] = Core;